import BillingAddressBlock from "./component/BillingAddressBlock"
import CurrentPlanBlock from "./component/CurrentPlanBlock"
import InvoiceLayout from "./component/invoice/InvoiceLayout"
import InvoiceBlock from "./component/InvoiceBlock"
import BillIndex from "./screens/BillIndex"
import ChangePlanPage from "./screens/ChangePlanPage"
import CreateOrder from "./screens/CreateOrder"
import ManageAddons from "./screens/ManageAddons"



const rootPath = 'Plan'
export const billingRoutes = [
    {
        path: rootPath + '/billing',
        element: <BillIndex />,
        isProtected: true
    },
    {
        path: rootPath + '/currentPlan',
        element: <CurrentPlanBlock />,
        isProtected: true
    },
    {
        path: rootPath + '/Invoice',
        element: <InvoiceBlock />,
        isProtected: true
    },
    {
        path: rootPath + '/billing/change-plan',
        element: <ChangePlanPage />,
        isProtected: true
    },
    {
        path: rootPath + '/create-order',
        element: <CreateOrder />,
        isProtected: true
    },
    {
        path: rootPath + '/billing/manage-addons',
        element: <ManageAddons />,
        isProtected: true
    },
    {
        path: rootPath + '/default/:id',
        element: <InvoiceLayout />,
        isProtected: true
    },
    {
        path: rootPath + '/address',
        element: <BillingAddressBlock />,
        isProtected: true
    },

]
